// Module
var code = "<template class=\"${updating ? '--updating' : ''}\"> <require from=\"./update-salary-information.scss\"></require> <icon name=\"update\"></icon> <u><slot></slot></u> </template> ";
// Exports
module.exports = code;